import { render, staticRenderFns } from "./questions-list.vue?vue&type=template&id=2a0b8947&scoped=true&"
import script from "./questions-list.vue?vue&type=script&lang=js&"
export * from "./questions-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0b8947",
  null
  
)

export default component.exports